export enum BestFitAIItemType {
	QUESTION = 'question',
	ANSWER = 'answer'
}